import { render } from "./ButtonSaveAll.vue?vue&type=template&id=3cf5640c"
import script from "./ButtonSaveAll.vue?vue&type=script&lang=js"
export * from "./ButtonSaveAll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__